import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getApiBase, getAuthHeaders } from '../../utils/api';
import { useParadigm } from '../../contexts/ParadigmContext';

const CreateTrip = () => {
  const { labels } = useParadigm();
  const [title, setTitle] = useState('');
  const [executives, setExecutives] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        const res = await axios.get(`${getApiBase()}/executives`, { headers: getAuthHeaders() });
        setExecutives(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        setExecutives([]);
      }
    };
    fetchExecutives();
  }, []);

  const createTrip = async () => {
    try {
      const payload = { id: crypto.randomUUID(), title, status: 'planning' };
      await axios.post(`${getApiBase()}/trips`, payload, { headers: getAuthHeaders() });
      navigate('/trips');
    } catch (e) {
      alert('Failed to create trip');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Create Trip</h2>
      <div className="mb-3">
        <label className="block text-sm mb-1">Title</label>
        <input className="border px-2 py-1 w-80" value={title} onChange={e => setTitle(e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="block text-sm mb-1">{labels.executiveOptional}</label>
        <select className="border px-2 py-1 w-80">
          {executives.map(e => (
            <option key={e.id} value={e.id}>{e.full_name || `${e.first_name || ''} ${e.last_name || ''}`}</option>
          ))}
        </select>
      </div>
      <button className="bg-indigo-600 text-white px-3 py-1 rounded" onClick={createTrip}>Create</button>
    </div>
  );
};

export default CreateTrip;